// Tile Layer Extension with GetFeature Info on Layer click
import L from "leaflet";
import axios from "axios"


L.TileLayer.BetterWMS = L.TileLayer.WMS.extend({

    onAdd: function (map) {
        L.TileLayer.WMS.prototype.onAdd.call(this, map);
        map.on('click', this.getFeatureInfo, this);
    },

    onRemove: function (map) {
        L.TileLayer.WMS.prototype.onRemove.call(this, map);
        map.off('click', this.getFeatureInfo, this);
    },

    getFeatureInfo: function (evt) {
        let url = this.getFeatureInfoUrl(evt.latlng);
        let showResults = L.Util.bind(this.showGetFeatureInfo, this);

        axios.get(url, {responseType: 'document'}).then(response => {
            const err = typeof response.data === 'string' ? null : response.data;
            showResults(err, evt.latlng, response.data)
        }).catch(error => {
            showResults(error)
        })
    },

    getFeatureInfoUrl: function (latlng) {
        // Construct a GetFeatureInfo request URL given a point
        const point = this._map.latLngToContainerPoint(latlng, this._map.getZoom());
        const size = this._map.getSize();

        let params = {
            request: 'GetFeatureInfo',
            service: 'WMS',
            srs: 'EPSG:4326',
            styles: this.wmsParams.styles,
            transparent: this.wmsParams.transparent,
            version: this.wmsParams.version,
            format: this.wmsParams.format,
            bbox: this._map.getBounds().toBBoxString(),
            height: size.y,
            width: size.x,
            layers: this.wmsParams.layers,
            query_layers: this.wmsParams.layers,
            info_format: 'text/xml'
        };

        params[params.version === '1.3.0' ? 'i' : 'x'] = point.x;
        params[params.version === '1.3.0' ? 'j' : 'y'] = point.y;

        if (this.wmsParams.hasOwnProperty("time")) {
            params.time = this.wmsParams.time
        }

        return this._url + L.Util.getParamString(params, this._url, true);
    },

    showGetFeatureInfo: function (err, latlng, featureInfo) {
        const content = createPopUpContent(this, featureInfo);
        L.popup()
            .setLatLng(latlng)
            .setContent(content)
            .openOn(this._map);
    }
});

function createPopUpContent(layer, featureInfo) {
    let result = parseLayerXml(layer, featureInfo);

    let markup = `
        <h4>${layer.title}</h4>
        <p>Ausgewählter Punkt:</p>
        <table>
            ${result.map(row => `<tr><td>${row[0]}</td><td>${row[1]}</td></tr>`).join("")}
        </table>
    `;
    return markup
}

function check_layer_availability(featureInfo) {
    return featureInfo.children[0].children.length > 1
}

function parseLayerXml(layer, featureInfo) {
    let result;
    if (layer.name === "agrode_ndv_daily_10" && check_layer_availability(featureInfo)){
        let array = Array.from(featureInfo.children[0].children[1].children[0].children);
        let number = Number(array.filter(x => x.localName === "GRAY_INDEX")[0].innerHTML);
        result = [["Wert", String(number)]]
    }
    else if (layer.name === "DEM_v11_Masked2"){
        let value = featureInfo.children[0].children[0].attributes.PixelValue.value;
        if (value !== "NoData"){
            value += " m"
        }
        return [["Wert", value]]
    }
    else if (["jki_aspect", "jki_twi", "jki_slope"].includes(layer.service)){
        let array = Array.from(featureInfo.children[0].children[0].children[0].attributes);
        result = [["Wert", array[0].value]]
    }
    else if (layer.service === "jki_mosaik"){
        let array = Array.from(featureInfo.children[0].children[0].children);
        result = array.map(x => [x.attributes.name.value, x.attributes.value.value])
    }
    else if (check_layer_availability(featureInfo)){
        const array = Array.from(featureInfo.children[0].children[1].children[0].children);
        result = array.map(x => [x.localName, x.innerHTML]);
    }
    else {
        result = [["Wert", "Nicht verfügbar"]]
    }
    return result;
}

const wmsLayerFeature = function (url, options) {
    return new L.TileLayer.BetterWMS(url, options);
};

export default wmsLayerFeature

